/** A rate card's own page gives each tab its own route, `/rate-cards/:id/<tab>` (`recordTabRoutes`). */
export const RATE_CARD_TABS = ['lines', 'accessorial-rates', 'proposals'] as const;
export type RateCardTab = (typeof RATE_CARD_TABS)[number];

export const RATE_CARD_TAB_LABELS: Record<RateCardTab, string> = { lines: 'Lines', 'accessorial-rates': 'Accessorial rates', proposals: 'Proposals' };

export const RATE_CARDS_PATH = '/rate-cards';
export const RATE_CARD_APPROVALS_PATH = '/rate-cards/approvals';

export function rateCardPath(id: string): string {
  return `${RATE_CARDS_PATH}/${id}`;
}

export function rateCardTabPath(id: string, tab: RateCardTab): string {
  return `${rateCardPath(id)}/${tab}`;
}
export const RATE_CARD_OFFCARD_REPORT_PATH = '/rate-cards/off-card-report';

/** Below the Lines tab, not a tab itself — a spreadsheet round trip for this card's prices (gitaumoses4/chukua#28). */
export function rateCardImportPath(id: string): string {
  return `${rateCardTabPath(id, 'lines')}/import`;
}
